import { useDocumentTitle } from "../../hooks";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import MenuItem from "../../components/admin/menu/MenuItem";
import { getInspectionTemplateTopPage } from "../../api/setting/pageApi";
import { setPageSettings } from "../../store/actions/pageActions";
import BackendLayout from "../../layouts/BackendLayout";
import { getRouteBreadcrumb } from "../../services/BreadcrumbServices";
import { INSPECTION_TEMPLATE_MASTER_DASHBOARD } from "../../constants/routes";
import { PageTitle } from "../../components/admin";
import { clearPageLoading, setPageLoading } from "../../store/actions";
import {errorStatusHandle} from "../../utils";
import {INSPECTION_TEMPLATE_MASTER_DASHBOARD_PAGE} from "../../constants/pageName";
import useRedirectPage from "../../hooks/useRedirectPage";
import {RedirectAlert} from "../../components";

const InspectionTemplateTopPage = () => {
  useRedirectPage(INSPECTION_TEMPLATE_MASTER_DASHBOARD_PAGE);
  const [menuItems, setMenuItems] = useState([]);
  const dispatch = useDispatch();
  useDocumentTitle("点検テンプレートマスタトップ - 点検王");
  const breadcrumb = getRouteBreadcrumb(INSPECTION_TEMPLATE_MASTER_DASHBOARD);

  //Function help to set page settings
  const setInspectionTemplateTopPageSettings = async (e) => {
    dispatch(setPageLoading());
    try {
      const pageSettings = await getInspectionTemplateTopPage();
      dispatch(setPageSettings(pageSettings));
      setMenuItems(pageSettings.menu_items);
    } catch (e) {
      errorStatusHandle(e);
    } finally {
      dispatch(clearPageLoading());
    }
  };

  useEffect(() => {
    setInspectionTemplateTopPageSettings();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <BackendLayout breadcrumb={breadcrumb}>
      <PageTitle title="点検テンプレートマスタトップ" />
      <RedirectAlert />
      <div className="grid inpection-master-items 2xl:gap-x-8 gap-y-8 py-[20px]">
        {menuItems.map((item, index) => (
          <MenuItem key={index} menu={item.name} feature="inspection-templates" />
        ))}
      </div>
    </BackendLayout>
  );
};

export default InspectionTemplateTopPage;
